import { useState } from "react";
import { faqs } from "@/mocks/faqs";
import SectionHeader from "@/components/base/SectionHeader";

const faqLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.question,
    acceptedAnswer: { "@type": "Answer", text: f.answer },
  })),
};

export default function FAQ() {
  const [openId, setOpenId] = useState<string | null>("faq1");

  return (
    <section id="faq" className="w-full bg-background-50 px-4 py-14 md:px-6 md:py-20">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqLd) }}
      />
      <div className="mx-auto grid w-full max-w-7xl grid-cols-1 gap-10 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <SectionHeader
            eyebrow="常见问题"
            title="关于吃瓜视频在线，你可能想知道"
            subtitle="筛选、来源、收藏、播放、反馈……这里汇总了大家最常问的问题，一次讲清楚。"
          />
          <div className="mt-6 flex flex-col gap-4 rounded-2xl border border-background-200/70 bg-background-100/60 p-5">
            <div className="flex items-center gap-3">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-primary-100 text-primary-600">
                <i className="ri-customer-service-2-line text-lg" />
              </span>
              <div>
                <p className="text-sm font-bold text-foreground-950">还有疑问？</p>
                <p className="text-xs text-foreground-500">随时联系我们的编辑团队</p>
              </div>
            </div>
            <a
              href="#contact"
              className="flex items-center justify-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-mail-send-line" />
              去留言反馈
            </a>
          </div>
        </div>

        <div className="flex flex-col gap-3 lg:col-span-8">
          {faqs.map((item) => {
            const open = openId === item.id;
            return (
              <div
                key={item.id}
                className={`overflow-hidden rounded-xl border transition-colors ${
                  open ? "border-primary-200 bg-primary-50/40" : "border-background-200/70 bg-background-100/50"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenId(open ? null : item.id)}
                  aria-expanded={open}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="flex items-center gap-3 text-sm font-bold text-foreground-950 md:text-[15px]">
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-xs font-bold ${
                        open ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                      }`}
                    >
                      Q
                    </span>
                    {item.question}
                  </span>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-all ${
                      open ? "rotate-45 bg-primary-100 text-primary-600" : "bg-background-200 text-foreground-600"
                    }`}
                  >
                    <i className="ri-add-line text-base" />
                  </span>
                </button>
                {open && (
                  <div className="px-5 pb-5 pl-12">
                    <p className="text-sm leading-relaxed text-foreground-700">{item.answer}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}